export const components = {
  documentTypingPad: {
    placeholder: 'Introduza su DNI a continuación',
    validation_error: 'Por favor, proporcione un número de DNI válido',
  },
  user_identification: {
    documentButtonText: 'Identificación con DNI',
    cpf_identification_failed:
      'No se puede encontrar un usuario con este número de DNI',
  },
};
